import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import Styles from "./Progress.module.scss";

export const Progress = ({
  id,
  className,
  progress,
  progressBarClassName
}) => {
  const _attr = {};
  if (id) _attr.id = id;
  if (className) _attr.className = classnames(className);

  return (
    <div {..._attr}>
      <div
        className={classnames(progressBarClassName)}
        style={{width: `${progress}%`}}/>
    </div>
  );
};

Progress.defaultProps = {
  id: null,
  className: Styles["progress"],
  progressBarClassName: Styles["progress-bar"],
  progress: 0
};

Progress.propTypes = {
  id: PropTypes.string,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.objectOf(PropTypes.bool)
  ]),
  progress: PropTypes.number
};
